/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Milestone_ReachedInputs */

const en_us2_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone`)
};

const pt_br2_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco`)
};

const es_419_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro`)
};

const pt_pt2_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco`)
};

const fr_fr2_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cap`)
};

const de_de2_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein`)
};

const it_it2_milestone_reached = /** @type {(inputs: Milestone_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traguardo`)
};

/**
* | output |
* | --- |
* | "Milestone" |
*
* @param {Milestone_ReachedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const milestone_reached = /** @type {((inputs?: Milestone_ReachedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Milestone_ReachedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_milestone_reached(inputs)
	if (locale === "es-419") return es_419_milestone_reached(inputs)
	if (locale === "pt-PT") return pt_pt2_milestone_reached(inputs)
	if (locale === "fr-FR") return fr_fr2_milestone_reached(inputs)
	if (locale === "de-DE") return de_de2_milestone_reached(inputs)
	if (locale === "it-IT") return it_it2_milestone_reached(inputs)
	return en_us2_milestone_reached(inputs)
});
export { milestone_reached as "milestone.reached" }